"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrillantField = void 0;
var BrillantField;
(function (BrillantField) {
    BrillantField["groesse"] = "groesse";
    BrillantField["twsi"] = "twsi";
    BrillantField["wsi"] = "wsi";
    BrillantField["twif"] = "twif";
    BrillantField["princess"] = "princess";
    BrillantField["siSchwarz"] = "siSchwarz";
    BrillantField["siBlau"] = "siBlau";
    BrillantField["siGruen"] = "siGruen";
    BrillantField["siBraun"] = "siBraun";
    BrillantField["siGelb"] = "siGelb";
    BrillantField["rubin"] = "rubin";
    BrillantField["saphir"] = "saphir";
    BrillantField["smaragd"] = "smaragd";
    BrillantField["zirkonia"] = "zirkonia";
})(BrillantField = exports.BrillantField || (exports.BrillantField = {}));
//# sourceMappingURL=BrillantField.js.map